export interface ApiErrorResponse {
  response?: {
    status?: number
    data?: {
      error?: string
      message?: string
    }
  }
  message?: string
  code?: string
}

export const getApiErrorMessage = (error: unknown): string | undefined => {
  const apiError = error as ApiErrorResponse
  return apiError?.response?.data?.error || apiError?.response?.data?.message
}

export interface ErrorConfig {
  showGlobalErrorForStatuses: number[]
  showGlobalErrorForCodes: string[]
  showGlobalErrorForNetworkErrors: boolean
  showGlobalErrorForServerErrors: boolean
  showGlobalErrorOnlyForJail: boolean
}

export const defaultErrorConfig: ErrorConfig = {
  showGlobalErrorForStatuses: [423],
  showGlobalErrorForCodes: [
    "NETWORK_ERROR",
    "TIMEOUT",
    "CONNECTION_REFUSED",
    "JAIL_ERROR"
  ],
  showGlobalErrorForNetworkErrors: true,
  showGlobalErrorForServerErrors: true,
  showGlobalErrorOnlyForJail: true
}

export const shouldShowGlobalError = (
  error: any,
  config: ErrorConfig = defaultErrorConfig
): boolean => {
  if (config.showGlobalErrorOnlyForJail) {
    return isJailError(error)
  }

  if (
    error?.response?.status &&
    config.showGlobalErrorForStatuses.includes(error.response.status)
  ) {
    return true
  }

  if (error?.code && config.showGlobalErrorForCodes.includes(error.code)) {
    return true
  }

  if (
    config.showGlobalErrorForNetworkErrors &&
    (error?.name === "NetworkError" ||
      error?.code === "NETWORK_ERROR" ||
      !error?.response)
  ) {
    return true
  }

  if (config.showGlobalErrorForServerErrors && error?.response?.status >= 500) {
    return true
  }

  return false
}

export const isJailError = (error: any): boolean => {
  const message = error?.message || error?.data?.message || ""
  if (message?.toLowerCase().includes("jail")) {
    return true
  }

  const responseData = error?.response?.data || error?.data || {}
  const responseDataStr = JSON.stringify(responseData)?.toLowerCase()
  if (responseDataStr.includes("jail")) {
    return true
  }

  const errorCode = error?.code || error?.data?.code || ""
  if (errorCode && errorCode?.toLowerCase()?.includes("jail")) {
    return true
  }

  const status = error?.response?.status || error?.status
  if (status === 423) {
    return true
  }

  return false
}
